import { rem } from '@bonusly/ds-utils';

export const FORM_PANEL_WIDTH = rem(820);
